import { CameraControls, PerspectiveCamera } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useEffect, useRef } from 'react';

import { CAMERA_POSITION } from '../constants';

// import { useFitObjectToView } from '../hooks';

export default function RetargetingCamera({
  highlightBone,
  hoistCameraControls,
}: {
  highlightBone?: THREE.Bone;
  hoistCameraControls?: (cameraControls: CameraControls) => void;
}) {
  const { camera } = useThree();
  const cameraControlsRef = useRef<CameraControls | null>(null);

  // Initialize camera once controls are available
  useEffect(() => {
    if (cameraControlsRef.current) {
      console.log('Camera controls ready, setting position');
      cameraControlsRef.current.setLookAt(
        CAMERA_POSITION.x,
        CAMERA_POSITION.y,
        CAMERA_POSITION.z,
        0,
        0.87,
        0,
      );

      hoistCameraControls?.(cameraControlsRef.current);
    }
  }, [camera]);

  // useEffect(() => {
  //   if (highlightBone) {
  //     cameraControlsRef.current?.fitToBox(highlightBone, true);
  //   }
  // }, [highlightBone]);

  return (
    <>
      <PerspectiveCamera makeDefault position={CAMERA_POSITION} />
      <CameraControls ref={cameraControlsRef} />
    </>
  );
}
